import { createPortal } from 'react-dom';
import React, { useContext, Fragment, useState, useEffect, useRef } from 'react';
import {
  withStyles,
  Grid,
  Fade,
  Drawer,
  Divider,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import DataContext from '../data/DataContext';
import Close from '../../asset/img/icon_close.svg';
import { sendPhoneVeriCode, validatePhoneVeriCode } from '../data/DataLoader';
import Error from '../../asset/img/icon_error.svg';
import Terms3 from './Terms3';
import CheckOn from '../../asset/img/icon_checkbox_on.svg';
import CheckOff from '../../asset/img/icon_checkbox_off.svg';
const styles = (theme) => ({
  root: {
    display: 'flex',
    letterSpacing: '-0.0313rem',
  },
  drawerFrame: {
    borderRadius: '0',
    borderBottomRightRadius: '0',
    borderBottomLeftRadius: '0',
    height: '100%',
    overflowY: 'auto',
    transform: 'none',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
    position: 'fixed',
    zIndex: '1300',
    inset: '0',
    background: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  dividerTitle: {
    height: '0.0625rem',
    background: '#000',
    margin: '0rem 0.875rem 1.2188rem 0.875rem',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '0.0625rem 0rem',
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '1.5rem',
      height: '1.5rem',
      cursor: 'pointer',
    },
  },
  drawerHeaderClose: {
    position: 'fixed',
    height: '4.375rem',
    background: '#fff',
    width: '100%',
    zIndex: '1',
  },
  closeContainer: {
    display: 'flex',
    minHeight: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  componentWrapper: {
    overflowY: 'auto',
    paddingTop: '4.375rem',
  },
  loading: {
    zIndex: '2000',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffffd9',
  },
  loadComplete: {
    display: 'none',
  },
  dialogRoot: {
    borderRadius: '0.625rem',
    width: '90%',
    maxWidth: '37.5rem',
  },
  dialogContent: {
    fontFamily: 'inherit',
    fontSize: theme.font.size16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
    padding: '2.5rem 1.25rem 0.9375rem !important',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'cneter',
    padding: '0.9375rem',
    '& button': {
      height: '3.125rem',
      width: '50%',
      borderRadius: '0.375rem',
      border: 'solid 0.0625rem #ea1917', //"solid 0.0625rem #da0f47",
      fontFamily: 'inherit',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.43',
      letterSpacing: 'normal',
      textAlign: 'center',
    },
  },
  dialogFooterBtnLeft: {
    background: '#fff',
    color: '#000',
    border: 'solid 0.0625rem #ddd !important',
  },
  dialogFooterBtnRight: {
    background: '#ea1917', //"#da0f47",
    color: '#fff',
  },
  divider: {
    height: '0.0625rem',
    backgroundColor: theme.color.divider.grey,
    width: '100%',
  },
  button: {
    minHeight: '2.5rem',
    textAlign: 'center',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0rem',
    margin: '0rem',
    flex: 1,
    backgroundColor: '#ea1917', //"#da0f47;",
    textTransform: 'none',
    // outline: '0 none',
    border: '0rem',
    // borderRadius: "0rem 0rem 0.75rem 0.75rem",
    // "&:active": {
    //   backgroundColor: "rgba(38, 38, 38, 0.1)",
    // },
  },
  buttonText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: '2.5rem',
    color: '#fff',
    padding: '0rem 1.25rem',
    fontSize: theme.font.size14,
    textAlign: 'center',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ' 1rem',
    marginTop: '1rem',
    placeContent: 'center',
    borderTop: '0.0625rem solid #ddd',
  },
  modalButton: {
    width: '100%',
    height: '3.125rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #ddd',
    backgroundColor: '#fff',
    fontFamily: 'NotoSansKR',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonLeft: {
    paddingRight: '0.25rem',
  },
  modalButtonRight: {
    paddingLeft: '0.25rem',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0rem',
  },
  modalGridContainer: {},
  modalGridItemLabel: {
    padding: '0.75rem 1rem 0rem 1rem',
  },
  modalGridItemLabelFirst: {
    padding: '0.25rem 1rem 0rem 1rem',
  },
  modalGridItem: {
    padding: '0.75rem 1rem',
  },
  modalLabel: {
    // minHeight: "1.25rem",
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',

    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', //"#da0f47"
    },
  },
  terms: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textareaField: {
    position: 'relative',
  },
  termTextArea: {
    height: '7.5rem',
    border: '0.0625rem solid #929292',
    borderRadius: '0.375rem 0.375rem 0 0',
    fontSize: theme.font.size12,
    padding: '1rem',
    lineHeight: '1.72',
    '& .termsDl': {
      height: '5.45rem',
      overflow: 'auto',
    },
    '& dl': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& dd': {
      marginInlineStart: '0rem',
    },
    '& ol': {
      listStyleType: 'none',
      paddingInlineStart: '0rem',
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& li': {
      listStyleType: 'none',
      paddingInlineStart: '0',
    },
    '& ol.termsOl>li': {
      paddingBlockStart: '0.5rem',
      '&:first-child': {
        paddingBlockStart: '0rem',
      },
    },
    '& ul': {
      paddingInlineStart: '0.625rem',
    },
    '& dt': {
      fontWeight: 'bold',
    },
    '& .layerPopupTop': {
      display: 'none',
    },
    '& .type2.contentsLyrPopx': {
      display: 'none',
    },
    '& .layerTopBtn': {
      display: 'none',
    },
    '& .termsDl .blind': {
      display: 'none',
    },
    '& .layerPopupBottom': {
      display: 'none',
    },
  },
  termTextContent: {
    height: '5.45rem',
    overflowY: 'scroll',
  },
  termTextTitle: {
    fontWeight: 'bold',
  },
  checkArea: {
    height: '3rem',
    border: '0.0625rem solid #929292',
    borderTop: 'none',
    borderRadius: '0 0 0.375rem 0.375rem',
    fontSize: theme.font.size12,
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    '& input+label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOff}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input:checked + label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOn}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input': {
      height: '1.25rem',
      width: '1.25rem',
      marginRight: '0.375rem !important',
      display: 'none',
    },
  },
  showAll: {
    fontWeight: 'bold',
    fontSize: theme.font.size12,
    letterSpacing: 'normal',
    textDecoration: 'underline',
    // cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: '#000',
  },
  errorIcon: {
    width: '0.75rem',
    height: '0.75rem',
    color: '#ff3723',
    marginRight: '0.1875rem',
  },
  errorText: {
    color: '#ff3723',
    fontSize: theme.font.size13,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '0.5rem',
  },
  modalField: {
    // paddingTop: "0.75rem",
    // "& input":{
    //   borderRadius: "0.375rem",
    //   width: "100%",
    //   height: "2.875rem",
    //   border: "solid 0.0625rem #929292",
    //   padding: "0.8125rem 1rem"
    // }
  },
  inputNormal: {
    borderRadius: '0.375rem',
    width: '100%',
    height: '2.875rem',
    border: 'solid 0.0625rem #929292',
    padding: '0.8125rem 1rem',
    fontSize: theme.font.size14,
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
  modalPlainBtn: {
    minHeight: '2.875rem',
    borderRadius: '0.375rem',
    // border: "solid 0.0625rem #000",
    // backgroundColor: "#fff",
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    // color: "#000",
  },
  modalInnerItem: {
    padding: '0rem',
    paddingRight: '0.5rem',
  },
  modalInnerItemLast: {
    paddingRight: '0rem',
  },
  time: {
    fontFamily: 'inherit',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.42',
    letterSpacing: 'normal',
    // textAlign: "center",
    color: '#ff3723',
    // position: "absolute",
    // paddingTop: "0.875rem",
    marginLeft: '-6.5rem',
  },
  redButton: {
    color: theme.color.button.rbut_text,
    backgroundColor: theme.color.button.rbut_bg,
    border: '0',
  },
  redButtonDisable: {
    color: theme.color.button.rbut_text_disable,
    backgroundColor: theme.color.button.rbut_bg_disable,
    border: '0',
  },
  whiteButton: {
    color: theme.color.button.wbut_text,
    backgroundColor: theme.color.button.wbut_bg,
    border: `solid 0.0625rem ${theme.color.button.wbut_border}`,
  },
  whiteButtonDisable: {
    color: theme.color.button.wbut_text_disable,
    backgroundColor: theme.color.button.wbut_bg_disable,
    border: `solid 0.0625rem ${theme.color.button.wbut_border_disable}`,
  },
  normalButton: {
    color: theme.color.text_color.black,
    backgroundColor: theme.color.button.background_white,
    border: `solid 0.0625rem ${theme.color.text_color.black}`,
  },
  normalButtonDisable: {
    color: theme.color.button.text_red_disable,
    backgroundColor: theme.color.button.background_white_disable,
    border: `solid 0.0625rem ${theme.color.button.background_red_disable}`,
  },
  inputDisable: {
    backgroundColor: theme.color.input.modal_disable,
    border: '0',
  },
  errorPopupContainer: {
    position: 'absolute',
    zIndex: '10',
    // bottom: "6.25rem",
    width: '100%',
    padding: '0 1rem',
    margin: '-2.5rem 0 0 0 ',
  },
  fadeoutEffect: {
    transition: 'all .5s ease-in-out',
  },
  errorPopupClosed: {
    height: 0,
  },
  errorPopup: {
    borderRadius: '0.375rem',
    boxShadow: '0.25rem 0.25rem 1.5rem 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    textAlign: 'left',
    padding: '1rem 1.25rem',
    color: theme.color.button.text_white,
    lineHeight: '1.43',
    letterSpacing: 'normal',
    fontSize: theme.font.size14,
    // margin: "0 1rem"
  },
  codeBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  btnClose: {
    border: 'none',
    background: 'none',
  },
  extendTime: {
    position: 'absolute',
    right: '0.8125rem',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  extendTimeButton: {
    height: '2rem',
    background: 'none',
    border: 'none',
    textDecoration: 'underline',
  },
});

const PhoneModal = withStyles(styles)((props) => {
  const { classes, modalClose, data, setCloseDialogOpen } = props;
  const context = useContext(DataContext);
  const [username, setUsername] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [phonenum, setPhonenum] = useState('');
  const [phonenumError, setPhonenumError] = useState('');
  const [userCode, setUserCode] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [timeLeft, setTimeLeft] = useState(0);
  const [limitTimer, setLimitTimer] = useState(null);
  const [isSendNum, setIsSendNum] = useState(false);
  const [canResend, setCanResend] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(undefined);
  const [checked, setChecked] = useState(false);
  const [popupTimer, setPopupTimer] = useState('');
  const [termText, setTermText] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const defaultTimeout = 3 * 60 * 1000;
  const resendTime = 1 * 60 * 1000;
  const minDigitCount = 9;
  const popupShowTime = 5 * 1000;

  useEffect(() => {
    return () => {
      clearInterval(limitTimer);
    };
  }, [limitTimer]);

  useEffect(() => {
    return () => {
      clearInterval(popupTimer);
    };
  }, [popupTimer]);

  useEffect(() => {
    (async () => {
      let response = await fetch('/ext/reservation/html/terms/terms_3_kr.html');
      let term_text = await response.text();
      setTermText(term_text);
    })();
  }, []);

  const handleCheckClick = () => {
    setAgreeTerms((prev) => !prev);
    setChecked((prev) => !prev);
  };

  const activeEnter = (e) => {
    if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
      handleCheckClick();
    }
  };

  const showErrorPopup = (msg) => {
    setErrorMsg(msg);
    const timeoutID = setTimeout(() => {
      setErrorMsg('');
    }, popupShowTime);
    setPopupTimer(timeoutID);
  };

  const checkValidPhonenum = (phonenumber) => {
    return /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/gi.test(phonenumber);
  };

  const checkValidUsername = (username) => {
    return /[^a-z|A-Z|ㄱ-ㅎ|가-힣]/.test(username);
  };

  const handleUsernameChange = (event) => {
    const tempUsername = event.target.value;
    setUsername(tempUsername);
    console.log(tempUsername);
    if (tempUsername?.length <= 0) {
      setUsernameError('이름을 입력해주세요.');
    } else if (checkValidUsername(tempUsername)) {
      setUsernameError(context.string.modal.nameValidError);
    } else if (tempUsername?.length > 50) {
      setUsernameError('이름은 1~50자 내로만 입력가능합니다.');
    } else {
      setUsernameError('');
    }
  };
  const getDigitCount = (phonenum) => {
    return phonenum.replace(/[^0-9]/g, '').length;
  };

  const phoneValidator = (telNum) => {
    var ment = '';
    var tel1 = '';
    var tel2 = '';
    var tel3 = '';
    var tel2_ = '';
    var result = '휴대전화 번호를 정확히 입력해 주세요';

    try {
      tel1 = telNum.substr(0, 3);
      tel2 = telNum.length === 10 ? telNum.substr(3, 3) : telNum.substr(3, 4);
      tel3 = telNum.substr(telNum.length - 4, 4);
      tel2_ = telNum.substr(3, 1);

      if (
        (tel1 === '011' ||
          tel1 === '016' ||
          tel1 === '017' ||
          tel1 === '018' ||
          tel1 === '019') &&
        tel2.length === 3
      ) {
        if (tel2 >= 200 && tel2 <= 899) {
          //return true;
        } else {
          ment =
            '국번 번호는 "200~899" 만 허용하며, "000~199", "900~999" 허용 불가합니다.';
        }
      }
      if (ment === '') {
        switch (tel1) {
          case '010':
            if (tel2_ === '0' || tel2_ === '1') {
              ment = '국번 번호의 첫자리가 "0, 1"은 잘못된 국번입니다.';
            } else {
              /*return true;*/
            }
            break;
          case '011':
            if (tel2.length === 4) {
              if ((tel2 >= 1700 && tel2 <= 1799) || (tel2 >= 9500 && tel2 <= 9999)) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "011" 이면 "1700~1799" 또는 "9500~9999" 만 허용합니다.';
              }
            } else if (tel2.length === 3) {
              if (tel2 >= 200 && tel2 <= 899) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "011" 이면 "200~899" 만 허용합니다.';
              }
            }
            break;
          case '016':
          case '019':
            if ((tel2 >= 200 && tel2 <= 899) || (tel2 >= 9000 && tel2 <= 9999)) {
              //return true;
            } else {
              ment =
                '국번 번호 범위가 맞지 않습니다. "016, 019" 이면 "9000~9999" 까지만 허용합니다.';
            }
            break;
          case '017':
          case '018':
            if (tel2.length === 4) {
              ment = '"017, 018"의 경우 국번은 4자리이면 안됩니다.';
            } else {
              if (tel2 >= 200 && tel2 <= 899) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "017, 018" 이면 "200~899" 까지만 허용합니다.';
              }
            }
            break;
          default:
            ment = '"010, 011, 016, 017, 018, 019" 만 허용합니다.';
            break;
        }
      }
      return ment === '' || false;
    } catch (er) {
      return false;
    } finally {
      console.log(
        '휴대폰번호 유효성 검사결과 : [tel1:' +
          tel1 +
          ', tel2:' +
          tel2 +
          ', tel3:' +
          tel3 +
          ', tel2_:' +
          tel2_ +
          ']' +
          ment
      );
    }
  };
  const handlePhonenumChange = (event) => {
    const inputString = event.target.value;
    setPhonenum(inputString);
    let noValidCharCount = inputString.replace(/[0-9\-]/g, '').length;
    let digitCount = getDigitCount(inputString); //inputString.replace(/[^0-9]/g,"").length;
    if (noValidCharCount > 0) {
      setPhonenumError(context.string.modal.phoneValidError);
    } else if (digitCount >= minDigitCount) {
      if (checkValidPhonenum(event.target.value) && phoneValidator(inputString)) {
        setPhonenumError('');
      } else {
        setPhonenumError(context.string.modal.phoneValidError);
      }
    } else {
      setPhonenumError();
    }
  };
  const handleUserCodeChange = (event) => {
    setUserCode(event.target.value);
  };

  const sendServerCode = async () => {
    let result = await sendPhoneVeriCode(context, phonenum);
    const debug_parameters = result.debug_parameters;
    result = result.result;
    if (debug_parameters.result_code !== '0000' || result.result !== 1) {
      if (result.resultMsg) {
        showErrorPopup(result.resultMsg);
      } else if (debug_parameters.message) {
        showErrorPopup(debug_parameters.message);
      }
    } else {
      setOtpCode(result.otp);
    }
  };

  const startLimitTimer = () => {
    let tempTime = defaultTimeout;
    setTimeLeft(tempTime);
    const timerId = setInterval(() => {
      tempTime -= 1000;
      if (defaultTimeout - tempTime === resendTime) {
        setCanResend(true);
      }
      // console.log(tempTime);
      if (tempTime < 0) {
        console.log('clearInterval');
        clearInterval(timerId);
        showErrorPopup(context.string.modal.inputTimeout);
      } else {
        setTimeLeft(tempTime);
      }
    }, 1000);
    setLimitTimer(timerId);
  };

  const handleSend = async () => {
    console.log('handleSend');
    // console.log(phonenum);
    // console.log(username);

    setIsSendNum(true);
    setCanResend(false);
    try {
      sendServerCode();
      startLimitTimer();
    } catch (error) {
      console.log(error);
    }
  };

  const handleResend = async () => {
    console.log('handleResend');
    clearInterval(limitTimer);
    // console.log(phonenum)
    // console.log(username);
    setCanResend(false);

    try {
      sendServerCode();
      startLimitTimer();
    } catch (error) {
      console.log(error);
    }
  };

  const handleExtendTime = async () => {
    console.log('handleExtendTime');
    clearInterval(limitTimer);
    setCanResend(false);

    try {
      startLimitTimer();
    } catch (error) {
      console.log(error);
    }
  };

  // [ChatbotV2] 점유인증 API에 전화번호 필수로 변경 24-07
  const handleSubmit = async () => {
    console.log('handleSubmit');
    let result = await validatePhoneVeriCode(context, userCode, otpCode, phonenum);

    // console.log('=============== context', context);
    // console.log('=============== userCode', userCode);
    // console.log('=============== otpCode', otpCode);
    // console.log('=============== phonenum', phonenum);

    const debug_parameters = result.debug_parameters;
    const validResult = result.result.validation;
    if (debug_parameters.result_code !== '0000') {
      showErrorPopup(context.string.modal.tempValidError);
    } else if (validResult === true) {
      clearInterval(limitTimer);
      let dataParameters = data?.parameters;

      // console.log('=============== dataParameters', dataParameters);

      let dataExpect = data?.expect || {
        mode: 'bypass',
        intent: 'THQ_QUICK_AUTH',
      };
      console.log(`Verification Sueccess`);
      context.request(
        context,
        dataParameters?.sppech || '인증하기',
        'button',
        {
          ...dataParameters,
          user_name: username,
          phone_number: phonenum,
          otp: otpCode,
          code: userCode,
        },
        dataExpect
      );
      modalClose();
    } else {
      // setCanResend(true);
      showErrorPopup(context.string.modal.codeIsWrong);
      console.log(`Verification Failed`);
    }
  };

  const timeLeftMin = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const timeLeftSec = `0${Math.floor((timeLeft % (1000 * 60)) / 1000)}`.slice(-2);

  const sendCodeButtonDisable =
    !username || getDigitCount(phonenum) < minDigitCount || phonenumError || isSendNum;
  const submitButtonDisable = !userCode || timeLeft <= 0 || !agreeTerms;
  const codeInputDisable = !isSendNum;
  const usernameInputDisable = isSendNum;
  const phonenumInputDisable = isSendNum;
  const [termModalOpen, setTermModalOpen] = useState(false);

  return (
    <Fragment>
      <Grid container className={classes.modalGridContainer}>
        {/* 이름 */}
        <Grid
          item
          xs={12}
          className={[classes.modalGridItemLabel, classes.modalGridItemLabelFirst].join(
            ' '
          )}
        >
          <div className={classes.modalLabel}>
            이름<span className="star">*</span>
          </div>
        </Grid>
        <Grid item xs={12} className={classes.modalGridItem}>
          <div className={classes.modalField}>
            <label htmlFor="userName" hidden>
              이름
            </label>
            <input
              disabled={usernameInputDisable}
              className={`${classes.inputNormal} ${
                usernameInputDisable && classes.inputDisable
              }`}
              type="text"
              onChange={handleUsernameChange}
              placeholder="이름을 입력해주세요"
              id="userName"
            />
          </div>
          {usernameError && (
            <div className={classes.errorText}>
              <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
              {usernameError}
            </div>
          )}
        </Grid>
        {/* 휴대전화번호 */}
        <Grid item xs={12} className={classes.modalGridItemLabel}>
          <div className={classes.modalLabel}>
            휴대전화번호<span className="star">*</span>
          </div>
        </Grid>
        <Grid container className={classes.modalGridItem}>
          <Grid item xs={8} className={classes.modalInnerItem}>
            <div className={classes.modalField}>
              <label htmlFor="phoneNumber" hidden>
                휴대전화번호
              </label>
              <input
                disabled={phonenumInputDisable}
                className={`${classes.inputNormal} ${
                  phonenumInputDisable && classes.inputDisable
                }`}
                type="tel"
                onChange={handlePhonenumChange}
                placeholder="휴대전화 번호를 입력해주세요"
                id="phoneNumber"
              />
            </div>
          </Grid>
          <Grid
            item
            xs={4}
            className={[classes.modalInnerItem, classes.modalInnerItemLast].join(' ')}
          >
            <div className={classes.modalField}>
              <button
                disabled={sendCodeButtonDisable}
                onClick={handleSend}
                className={`${classes.modalPlainBtn} ${
                  sendCodeButtonDisable
                    ? classes.normalButtonDisable
                    : classes.normalButton
                }`}
              >
                인증번호
              </button>
            </div>
          </Grid>
          {phonenumError && (
            <div className={classes.errorText}>
              <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
              {phonenumError}
            </div>
          )}
        </Grid>
        {/* 인증번호 */}
        <Grid item xs={12} className={classes.modalGridItemLabel}>
          <div className={classes.modalLabel}>
            인증번호<span className="star">*</span>
          </div>
        </Grid>
        <Grid container className={classes.modalGridItem}>
          <Grid item xs={9} className={classes.modalInnerItem}>
            <div className={classes.codeBox}>
              <label htmlFor="verificationNumber" hidden>
                인증번호
              </label>
              <input
                disabled={codeInputDisable}
                className={`${classes.inputNormal}
                ${codeInputDisable && classes.inputDisable}`}
                type="text"
                onChange={handleUserCodeChange}
                placeholder="인증번호 6자리"
                id="verificationNumber"
              />
              {timeLeft > 0 && (
                <span className={classes.time}>{`${timeLeftMin}:${timeLeftSec}`}</span>
              )}
              {timeLeft > 0 && (
                <div className={classes.extendTime}>
                  <button className={classes.extendTimeButton} onClick={handleExtendTime}>
                    시간연장
                  </button>
                </div>
              )}
            </div>
          </Grid>
          <Grid
            item
            xs={3}
            className={[classes.modalInnerItem, classes.modalInnerItemLast].join(' ')}
          >
            <div className={classes.modalField}>
              <button
                disabled={!canResend}
                onClick={handleResend}
                className={`${classes.modalPlainBtn} ${
                  canResend ? classes.normalButton : classes.normalButtonDisable
                }`}
              >
                재전송
              </button>
            </div>
          </Grid>
          {!canResend && isSendNum && (
            <div className={classes.errorText}>
              <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
              {context.string.modal.resendTimeLimit}
            </div>
          )}
        </Grid>
      </Grid>

      {/* 개인정보 수집 및 이용동의 */}
      <Grid item xs={12} className={classes.modalGridItemLabel}>
        <div className={[classes.modalLabel, classes.terms].join(' ')}>
          <div>
            개인정보 수집 및 이용동의<span className="star">*</span>
          </div>
          <button
            className={classes.showAll}
            onClick={() => {
              setTermModalOpen(true);

              const rootChild = document.getElementById('modal');
              const focusableElements = rootChild.querySelectorAll('*');

              for (let i = 0; i < focusableElements.length; i++) {
                focusableElements[i].setAttribute('aria-hidden', 'true');
              }
            }}
          >
            전문보기
          </button>
        </div>
      </Grid>
      <Grid item xs={12} className={classes.modalGridItem}>
        <div className={[classes.modalField, classes.textareaField].join(' ')}>
          <div className={classes.termTextArea}>
            <div
              className={classes.termTextContent}
              dangerouslySetInnerHTML={{ __html: termText }}
            />
          </div>
          {/* <input type="hidden" value={agreeTerms}  {...register("terms", {validate: ()=>checked})} name="checkHidden"/> */}
          <div className={classes.checkArea}>
            <input
              id="term_check"
              type="checkbox"
              checked={agreeTerms}
              onClick={handleCheckClick}
            />
            <label
              htmlFor="term_check"
              role="checkbox"
              aria-checked={checked}
              tabIndex="0"
              onKeyDown={(e) => activeEnter(e)}
              aria-label={
                agreeTerms === false
                  ? '먼저 약관 내용을 확인 후, 동의하셔야 이용 가능합니다.'
                  : null
              }
            >
              {' '}
              동의합니다.
            </label>
          </div>
        </div>
        {agreeTerms === false && (
          <div className={classes.errorText}>
            <img src={Error} className={classes.errorIcon} alt="체크 필요" />
            먼저 약관 내용을 확인 후, 동의하셔야 이용 가능합니다.
          </div>
        )}
      </Grid>

      {/* footer button */}
      <div>
        {errorMsg && (
          <div
            className={`${classes.errorPopupContainer} ${
              errorMsg ? classes.fadeoutEffect : classes.errorPopupClosed
            }`}
          >
            <Fade in={errorMsg}>
              <div className={classes.errorPopup}>{errorMsg}</div>
            </Fade>
          </div>
        )}
        <Grid container className={`${classes.modalFooter}`}>
          <Grid item xs={6} className={`${classes.modalButtonLeft}`}>
            <button
              type="button"
              className={`${classes.modalButton}`}
              onClick={() => setCloseDialogOpen(true)}
            >
              취소
            </button>
          </Grid>
          <Grid item xs={6} className={`${classes.modalButtonRight}`}>
            <button
              disabled={submitButtonDisable}
              onClick={() => handleSubmit()}
              className={`${classes.modalButton} ${
                submitButtonDisable ? classes.redButtonDisable : classes.redButton
              }`}
            >
              인증하기
            </button>
          </Grid>
        </Grid>
      </div>
      <Terms3
        modalOpen={termModalOpen}
        modalClose={() => {
          setTermModalOpen(false);
          const rootChild = document.getElementById('modal');
          const focusableElements = rootChild.querySelectorAll('*');

          for (let i = 0; i < focusableElements.length; i++) {
            focusableElements[i].removeAttribute('aria-hidden');
          }
        }}
        checkOk={(ok) => {
          setAgreeTerms(ok);
        }}
      />
    </Fragment>
  );
});

function ValidatePhone(props) {
  const { classes, data, modalOpen, modalClose } = props;
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  const close = () => {
    modalClose();
    setCloseDialogOpen(false);
  };

  return createPortal(
    <div className={classes.root}>
      {/* <Drawer
        anchor="bottom"
        open={modalOpen}
        onClose={() => setCloseDialogOpen(true)}
        classes={{ paper: classes.drawerFrame }}
      > */}
      {modalOpen && (
        <div className={classes.drawerFrame}>
          <div className={classes.drawerRoot}>
            <div className={classes.drawerHeaderClose}>
              <div className={classes.closeContainer}>
                <div
                  className={[classes.titleClose].join(' ')}
                  ref={modalRef}
                  tabIndex="0"
                >
                  휴대전화 인증
                </div>
                <div className={classes.close}>
                  <button
                    className={classes.btnClose}
                    onClick={() => setCloseDialogOpen(true)}
                  >
                    <img src={Close} className={classes.arrowDown} alt="닫기" />
                  </button>
                </div>
              </div>
              <Divider classes={{ root: classes.dividerTitle }} />
            </div>
            <div className={classes.componentWrapper}>
              <PhoneModal
                data={data}
                modalOpen={modalOpen}
                modalClose={modalClose}
                setCloseDialogOpen={setCloseDialogOpen}
                modalRef={modalRef}
              />
            </div>
          </div>
        </div>
      )}
      {/* </Drawer> */}
      <Dialog
        open={closeDialogOpen}
        onClose={() => setCloseDialogOpen(false)}
        classes={{ paper: classes.dialogRoot }}
      >
        <DialogContent classes={{ root: classes.dialogContent }}>
          지금 종료하시면 입력하신 <br />
          정보가 사라져요. 그만하시겠어요?
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogFooter }}>
          <button className={classes.dialogFooterBtnLeft} onClick={close}>
            그만하기
          </button>
          <button
            className={classes.dialogFooterBtnRight}
            onClick={() => setCloseDialogOpen(false)}
            autoFocus
          >
            계속하기
          </button>
        </DialogActions>
      </Dialog>
    </div>,
    document.getElementById('modal')
  );
}
export default withStyles(styles)(ValidatePhone);
